
  import { mapEntityProperties } from '@/utils/mapEntityProperties'
  import { SelectionEntity } from '../../domain/entities/SelectionEntity'
export class SelectionModel extends SelectionEntity {
  constructor(dataDto: SelectionEntity) {
    super()
    mapEntityProperties(this, dataDto)
  }
}